<script>

import axios from 'axios'

export default {
  data() {
    return {
      bikes: [],
      api: this.getApi(),
      bikeTypes: [],
      bikeUses: [],
      wheelSizes: [],
      frameTypes: [],
      frameMaterials: [],
      modelFamilies: [],
      showingGrabAttention: false,
      showingGrabAttentionTimeout: ''
    }
  },
  mounted() {
    this.getBikes()
  },
  watch: {
    bikeCount() {
      clearTimeout(this.showingGrabAttentionTimeout)
      this.showingGrabAttention = true
      this.showingGrabAttentionTimeout = setTimeout(() => { this.showingGrabAttention = false }, 2000)
    }
  },
  props: ['site', 'year'],
  computed: {
    extraConditions() {
      return (this.year !== 'all') ? 'bikeStatus: "archived", relatedTo: ' + this.year : 'bikeStatus: "active"'
    },
    computedBikes() {
      let data = []

      for (let bike of this.bikes) {
        let belongs = true
        if (this.bikeTypes.length) {
          belongs = false
          for (let thisBikeType of bike.bikeTypes) {
            if (this.bikeTypes.indexOf('biketype__' + thisBikeType.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (this.wheelSizes.length) {
          belongs = false
          for (let thisWheelSize of bike.bikeWheelSizes) {
            if (this.wheelSizes.indexOf('wheelsize__' + thisWheelSize.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (this.bikeUses.length) {
          belongs = false
          for (let thisBikeUse of bike.bikeUses) {
            if (this.bikeUses.indexOf('bikeuse__' + thisBikeUse.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (this.frameTypes.length) {
          belongs = false
          for (let thisFrameType of bike.bikeFrameTypes) {
            if (this.frameTypes.indexOf('frametype__' + thisFrameType.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (this.frameMaterials.length) {
          belongs = false
          for (let thisFrameMaterial of bike.bikeFrameMaterial) {
            if (this.frameMaterials.indexOf('framematerial__' + thisFrameMaterial.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (this.modelFamilies.length) {
          belongs = false
          for (let thisModelFamily of bike.bikeModelFamily) {
            if (this.modelFamilies.indexOf('modelfamily__' + thisModelFamily.slug) !== -1) {
              belongs = true
            }
          }
          if (!belongs) {
            continue
          }
        }

        if (belongs) {
          data.push(bike)
        }
      }

      return data
    },
    bikeCount() {
      return (this.computedBikes.length < this.bikes.length) ? this.computedBikes.length : 'All'
    },
    clearFiltersVisible() {
      return this.bikeTypes.length || this.bikeUses.length || this.wheelSizes.length || this.frameTypes.length || this.frameMaterials.length || this.modelFamilies.length
    },
    noResults() {
      return this.computedBikes.length === 0
    },
    dataLoaded() {
      return this.bikes.length > 0
    }
  },
  methods: {
    getBikes() {
      let query = `{
  entries (section: "bikes", siteId: "${this.site}", ${this.extraConditions}) {
    url
    ... on bikes_bikes_Entry {
      bikeName
      bikePrice
      bikePriceDiscountedFrom
      bikeDiscountedPriceLabel
      bikeLinkToBuyOnline
      bikeShopifyBuyButtonCode
      bikeGridImage {
        image1x: url @transform (transform: "bikesBikeGrid1x", immediately: true)
        image2x: url @transform (transform: "bikesBikeGrid2x", immediately: true)
        ... on images_Asset {
          title
          altText
        }
      }
      bikeTypes {
        id
        slug
        ... on bikeTypes_bikeTypes_Entry {
          bikeTypeName
        }
      }
      bikeWheelSizes {
        id
        slug
        ... on wheelSizes_wheelSizes_Entry {
          wheelSizeName
        }
      }
      bikeUses {
        id
        slug
        ... on bikeUses_bikeUses_Entry {
          bikeUseName
        }
      }
      bikeFrameTypes {
        id
        slug
        ... on frameTypes_frameTypes_Entry {
          frameTypeName
        }
      }
      bikeFrameMaterial {
        id
        slug
        ... on frameMaterials_frameMaterials_Entry {
          frameMaterialName
        }
      }
      bikeModelFamily {
        id
        slug
        ... on modelFamilies_modelFamilies_Entry {
          modelFamilyName
        }
      }
    }
  }
}`
      this.api.post('/api', {query: query})
        .then((response) => {
          this.bikes = response.data.data.entries
        })
    },
    getApi() {
      return axios.create({
        headers: {
          'Authorization': 'Bearer xudOiC2nNzN1te5hoI7frL0k13KLGR74',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
    },
    getBikeForSale(bike) {
      return bike.bikeLinkToBuyOnline || bike.bikeShopifyBuyButtonCode
    },
    getWheelSizes(bike) {
      let wheelSizes = []
      for (let wheelSize of bike.bikeWheelSizes) {
        wheelSizes.push(wheelSize.wheelSizeName)
      }
      return wheelSizes.join('/')
    },
    getFrameTypes(bike) {
      let frameTypes = []
      for (let frameType of bike.bikeFrameTypes) {
        frameTypes.push(frameType.frameTypeName)
      }
      return frameTypes.join('/')
    },
    getFrameMaterials(bike) {
      let frameMaterials = []
      for (let frameMaterial of bike.bikeFrameMaterial) {
        frameMaterials.push(frameMaterial.frameMaterialName)
      }
      return frameMaterials.join('/')
    },
    bikeHasImage(bike) {
      let data = false
      if (bike.bikeGridImage.length) {
        if (bike.bikeGridImage[0].image1x.length && bike.bikeGridImage[0].image2x.length) {
          data = true
        }
      }
      return data
    },
    getBikeImage1x(bike) {
      let data = ''
      if (bike.bikeGridImage.length) {
        if (bike.bikeGridImage[0].image1x.length) {
          data = bike.bikeGridImage[0].image1x
        }
      }
      return data
    },
    getBikeImage2x(bike) {
      let data = ''
      if (bike.bikeGridImage.length) {
        if (bike.bikeGridImage[0].image2x.length) {
          data = bike.bikeGridImage[0].image2x + ' 2x'
        }
      }
      return data
    },
    getBikeAltText(bike) {
      return (bike.bikeGridImage[0].altText) ? bike.bikeGridImage[0].altText : bike.bikeGridImage[0].title
    },
    hasBikeDescription(bike) {
      let wheelSizesExist = bike.bikeWheelSizes.length
      let frameTypesExist = bike.bikeFrameTypes.length
      let frameMaterialsExist = bike.bikeFrameMaterial.length
      return wheelSizesExist || frameTypesExist || frameMaterialsExist
    },
    getBikeDescription(bike, wheelSizeTranslation) {
      let data = ''
      let wheelSizesExist = bike.bikeWheelSizes.length
      let frameTypesExist = bike.bikeFrameTypes.length
      let frameMaterialsExist = bike.bikeFrameMaterial.length
      if (wheelSizesExist) {
        data = wheelSizeTranslation + ': ' + this.getWheelSizes(bike)
      }
      if (frameTypesExist) {
        if (wheelSizesExist) {
          data += ', '
        }
        data += this.getFrameTypes(bike)
      }
      if (frameMaterialsExist) {
        if (wheelSizesExist || frameTypesExist) {
          data += ', '
        }
        data += this.getFrameMaterials(bike)
      }

      return data

    },
    clearFilters() {
      this.bikeTypes = []
      this.bikeUses = []
      this.wheelSizes = []
      this.frameTypes = []
      this.frameMaterials = []
      this.modelFamilies = []
    }

  }
}
</script>
